"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TRIM = void 0;
exports.TRIM = {
    alias: 'ARRUMAR',
    description: 'Remove espaços em branco no começo e final do texto',
    arg_names: ['string_to_trim'],
    args_description: ['string a ser arrumada'],
};
